<template>
  <div class="breadcrumb-class">
    <el-breadcrumb separator="/">
      <template v-for="(item) in crumbsData">
        <el-breadcrumb-item v-if="jumpPageType(item)" :key="item.url"><a class="href-class" :href="item.url">{{item.name}}</a></el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="item.url" :key="item.url">{{item.name}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script> 
import {crumbsProps} from './index.js'
export default {
  name: 'crumbs',
  props: crumbsProps,
  methods: {
    jumpPageType (item) {
      let jupType = ['https', 'http']
      let flag = false
      jupType.forEach((itm) => {
        if (item.url.includes(itm)) {
          flag = true
        }
      })
      return flag
    }
  }
}
</script>

<style lang="scss" scoped>
  .breadcrumb-class {
    ::v-deep .el-breadcrumb__inner {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      color: #636E95;
      &:hover {
        color: #242F57 !important;
      }
    }
    ::v-deep .el-breadcrumb__separator {
      margin: 0 4px;
      color: #636E95;
    }
    .href-class {
      color: #636E95 !important;
      &:hover {
        color: #242F57 !important;
      }
    }
  }
</style>